// extracted by mini-css-extract-plugin
export default {"villageWrapper":"front-end_villageWrapper__zOZkr","cta":"front-end_cta__79+8z"};